import { Link } from "react-router-dom";
import TransactionHistoryList from "./TransactionHistoryList";

function RecentActivities() {
  return (
    <div className="col-span-1 bg-white drop-shadow-sm p-5 rounded-xl flex flex-col gap-5">
      <div className="flex justify-between items-center">
        <div className="text-lg">Recent Transactions</div>
      </div>
      <TransactionHistoryList max={5} />

      <div className="flex justify-between items-center">
        <Link
          to="/payments/history"
          className="text-blue-600 font-medium opacity-80 hover:opacity-100 transition"
        >
          Show All
        </Link>
      </div>
    </div>
  );
}

export default RecentActivities;
